import { utc } from '@vrplatform/utils';

export const getStatementHref = ({
  date,
  ownerId,
  listingId,
}: {
  listingId: string;
  ownerId?: string;
  date: string;
}) => {
  const dateFormat = 'YYYY-MM-DD';

  const base = `/statement/${listingId}`;

  const searchParams = new URLSearchParams();

  searchParams.set('date', utc(date).format(dateFormat));
  if (ownerId) {
    searchParams.set('statementOwnership', ownerId);
  }

  return `${base}?${searchParams.toString()}`;
};
